import CloseSmall from '@crehana/icons/outline/CloseSmall';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, Popper, TextLink, TextTag } from '@crehana/ui';
import { useUIContext } from "../../../context/UI";
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NoteAI = function NoteAI(_ref) {
  var ref = _ref.ref,
    hiddePopperAi = _ref.hiddePopperAi,
    isOpenPopper = _ref.isOpenPopper,
    isLg = _ref.isLg;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUIContext = useUIContext(),
    toogleGeneratedAI = _useUIContext.toogleGeneratedAI;
  var handleGenerate = function handleGenerate() {
    hiddePopperAi();
    toogleGeneratedAI('AI icon');
  };
  return /*#__PURE__*/_jsx(Popper, {
    anchorRef: ref,
    position: "top",
    dismissOnClickOutside: true,
    isVisible: isOpenPopper,
    onDismiss: hiddePopperAi,
    className: "!tw-bg-elevation-dark-04 tw-rounded-1 tw-absolute",
    setPosition: function setPosition() {
      return {
        top: '70%',
        left: isLg ? '40%' : '24%'
      };
    },
    "data-testid": "cp-generate-AI",
    children: /*#__PURE__*/_jsxs("article", {
      className: "max-w-360 overflow-hidden p-20 text-white whitespace-pre-line",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between mb-8",
        children: [/*#__PURE__*/_jsx(TextTag, {
          label: t('AI_TAG'),
          type: "green",
          className: "tw-rounded-[4rem] tw-bg-secondary-dark-400"
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-cursor-pointer",
          onClick: hiddePopperAi,
          onKeyDown: hiddePopperAi,
          children: /*#__PURE__*/_jsx(CloseSmall, {
            size: 16,
            color: colors.grayDark
          })
        })]
      }), /*#__PURE__*/_jsx("p", {
        className: "font-subtitle4 mb-8",
        children: t('AI_LABEL')
      }), /*#__PURE__*/_jsx("p", {
        className: "font-body4 mb-12",
        children: t('AI_DESCRIPTION')
      }), /*#__PURE__*/_jsx(TextLink, {
        label: t('AI_CTA_BUTTON'),
        onClick: handleGenerate
      })]
    })
  });
};
export default NoteAI;